import { v4 as uuidv4 } from 'uuid';
export function createNote(data) {
    const now = new Date().toISOString();
    // Empty or "/" is the root, stored as ''. Was only done in the app's hook,
    // so a note filed by the assistant under "/" sat in a folder named "/".
    const folder = data.folder_path?.trim();
    return {
        id: uuidv4(),
        title: data.title,
        content: data.content ?? '',
        folder_path: folder && folder !== '/' ? folder : '',
        linked_task_ids: data.linked_task_ids ?? [],
        linked_project_ids: data.linked_project_ids ?? [],
        linked_habit_ids: data.linked_habit_ids ?? [],
        linked_goal_ids: data.linked_goal_ids ?? [],
        is_daily_note: data.is_daily_note ?? false,
        date: data.date ?? null,
        tags: data.tags ?? [],
        created_at: now,
        updated_at: now,
    };
}
export function getNoteSafeTitle(title) {
    return title
        .replace(/[/\\]/g, '-')
        .replace(/[^a-zA-Z0-9 \-_]/g, '')
        .trim();
}
export function getNoteFilePath(note) {
    const safeTitle = getNoteSafeTitle(note.title);
    if (note.folder_path) {
        return `${note.folder_path}/${safeTitle}.md`;
    }
    return `${safeTitle}.md`;
}
//# sourceMappingURL=note.js.map